import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-daily-status',
  imports: [NgbTooltip],
  templateUrl: './daily-status.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./daily-status.component.scss']
})
export class DailyStatusComponent {
  @Input() day: string = '';
  @Input() status!: string;

}
